import { collection, query, where, getDocs, orderBy, limit } from 'firebase/firestore';
import { externalDb } from '../firebase/externalConfig';

// Serviço para buscar produtos externos diretamente no Firebase
export const externalProductService = {
  // Buscar produtos externos por referência
  async searchProductsByRef(searchTerm) {
    try {
      if (!searchTerm || searchTerm.trim().length < 2) {
        return [];
      }

      
      // Testar diferentes nomes de coleção
      const possibleCollections = ['produtos_externos', 'produtos', 'products', 'items', 'cadastro'];
      let foundCollection = null;
      
      for (const collectionName of possibleCollections) {
        try {
          const testRef = collection(externalDb, collectionName);
          const testQuery = query(testRef, limit(1));
          const testSnapshot = await getDocs(testQuery);
          
          if (!testSnapshot.empty) {
            foundCollection = collectionName;
            break;
          } else {
          }
        } catch (error) {
        }
      }
      
      if (!foundCollection) {
        return [];
      }
      
      const productsRef = collection(externalDb, foundCollection);
      
      // Tentar diferentes estratégias de busca
      let products = [];
      
      // 1. Busca por referência exata primeiro
      try {
        const exactQuery = query(
          productsRef,
          where('referencia', '==', searchTerm.toUpperCase()),
          limit(5)
        );
        const exactSnapshot = await getDocs(exactQuery);
        if (!exactSnapshot.empty) {
          products = exactSnapshot.docs.map(doc => {
            const data = doc.data();
            return { id: doc.id, ...data };
          });
        }
      } catch (error) {
      }
      
      // 2. Se não encontrou por exata, tentar busca por prefixo
      if (products.length === 0) {
        const searchQuery = query(
          productsRef, 
          where('referencia', '>=', searchTerm.toUpperCase()),
          where('referencia', '<=', searchTerm.toUpperCase() + '\uf8ff'),
          orderBy('referencia'),
          limit(20)
        );
        
        const querySnapshot = await getDocs(searchQuery);
        products = querySnapshot.docs.map(doc => {
          const data = doc.data();
          return {
            id: doc.id,
            ...data
          };
        });
      }
      
      if (products.length > 0) {
      }
      
      return products;
    } catch (error) {
      throw error;
    }
  },

  // Buscar produtos externos por referência exata
  async searchProductByExactRef(ref) {
    try {
      if (!ref) {
        return null;
      }

      
      const productsRef = collection(externalDb, 'produtos_externos');
      const q = query(productsRef, where('referencia', '==', ref.toUpperCase()));
      
      const querySnapshot = await getDocs(q);
      
      if (querySnapshot.empty) {
        return null;
      }
      
      const doc = querySnapshot.docs[0];
      return {
        id: doc.id,
        ...doc.data()
      };
    } catch (error) {
      throw error;
    }
  },

  // Buscar todos os produtos externos
  async getAllExternalProducts() {
    try {
      
      const productsRef = collection(externalDb, 'produtos_externos');
      const q = query(productsRef, orderBy('referencia'), limit(100));
      
      const querySnapshot = await getDocs(q);
      const products = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      
      return products;
    } catch (error) {
      throw error;
    }
  },

  // Função de teste para debug - buscar produtos que contenham "RV"
  async testSearchRV() {
    try {
      
      const productsRef = collection(externalDb, 'produtos_externos');
      
      // Teste 1: Verificar se conseguimos acessar o banco
      
      // Teste 2: Listar todas as coleções disponíveis (se possível)
      const testQuery = query(productsRef, limit(1));
      const testSnapshot = await getDocs(testQuery);
      
      if (!testSnapshot.empty) {
      }
      
      // Teste 3: Tentar outras possíveis coleções
      const possibleCollections = ['produtos', 'products', 'items', 'cadastro'];
      
      for (const collectionName of possibleCollections) {
        try {
          const testCollectionRef = collection(externalDb, collectionName);
          const testCollectionQuery = query(testCollectionRef, limit(1));
          const testCollectionSnapshot = await getDocs(testCollectionQuery);
          
          if (!testCollectionSnapshot.empty) {
          }
        } catch (error) {
        }
      }
      
      // Teste 4: Busca específica por "RV" na coleção produtos_externos
      const rvQuery = query(
        productsRef,
        where('referencia', '>=', 'RV'),
        where('referencia', '<=', 'RV\uf8ff'),
        limit(10)
      );
      
      const rvSnapshot = await getDocs(rvQuery);
      
      if (rvSnapshot.docs.length > 0) {
        rvSnapshot.docs.forEach((doc, index) => {
        });
      }
      
      return rvSnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
    } catch (error) {
      throw error;
    }
  }
};
